import { CircleInfoIcon } from '@domgen/base-design-system-2.0/icons/CircleInfoIcon';
import { BillingPaymentMethod } from '../hooks/useBillingAddressPlacement';

const styles = {
  container: 'mt-space-200 flex gap-space-100',
  iconContainer: 'flex items-center h-(--line-height-body-small)',
  text: 'text-body-small text-text-body',
};

const HINTS: Record<BillingPaymentMethod, string> = {
  ach: 'Must match the address on your bank account',
  card: 'Must match your card statement address, or the payment may be declined.',
};

/**
 * @description Hint under the billing address field in the checkout test variant, rendered into the
 * slot added after the SDK billing address. The stylesheet hides it while the address is edited.
 */
export const CheckoutBillingHint = ({ paymentMethod }: { paymentMethod: BillingPaymentMethod }) => (
  <div className={styles.container}>
    <div className={styles.iconContainer}>
      <CircleInfoIcon />
    </div>
    <p className={styles.text}>{HINTS[paymentMethod]}</p>
  </div>
);
